import { createAction } from 'lib/store-utils';

export const BOX_SHORTCUTS_MODAL_OPEN = createAction('Shortcuts modal / open');
export const BOX_SHORTCUTS_MODAL_CLOSE = createAction('Shortcuts modal / close');
